import React, { useState } from 'react'
import './adminStyles.css'
import { IoSearch } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import AdminSidebar from './Sidebar/AdminSidebar';
import AdminHeader from './Header/AdminHeader';

const Issuers = () => {

    const [sortFilter, setSortFilter] = useState("Newest Date");
    const navigation = useNavigate()

    const handleSortBy = (e) => {
        console.log(e.target.innerText.toLowerCase(), "iiuh");
        setSortFilter(e.target.innerText.toLowerCase());
    };

    const issuerTable = [
        {
            issuerID: 'ISS-0001',
            name: 'John Doe',
            country: 'Singapore',
            email:'john.doe@email.com',
            category:'Real Estate',
            dateSubmitted:'21 Sep 2025',
            status:'New',
        },
        {
            issuerID: 'ISS-0002',
            name: 'Maria Sanchez',
            country: 'UAE',
            email:'maria.s@email.com',
            category:'Private Eq.',
            dateSubmitted:'20 Sep 2025',
            status:'Approved',
        },
        {
            issuerID: 'ISS-0003',
            name: 'David Li',
            country: 'Hong Kong',
            email:'david.l@company.com',
            category:'Real Estate',
            dateSubmitted:'19 Sep 2025',
            status:'Reviewed',
        },
        {
            issuerID: 'ISS-0004',
            name: 'Sarah Johnson',
            country: 'Switzerland',
            email:'sarah.j@finfund.com',
            category:'Infra',
            dateSubmitted:'19 Sep 2025',
            status:'Contacted',
        },
    ]

    const redirectDetail = (value) => {
        if(value.toLocaleLowerCase() == 'new'){
            navigation("/admin/issuersDetails");
            console.log('csdcsd');
        }
        
    }

  return (
    <>
          <>
              <AdminHeader />

              <main className="main_flx userMang_main">
                  <AdminSidebar />

                  <div className="right_wrap pb-4">
                      <div>
                          <h3 className='inspge_title'>Issuer Details</h3>

                          <div className="search_select_wrp usrMng_selct_wrp">
                            <div className='pdf_csv_wrp'>
                                <button>PDF</button>
                                <button>csv</button>
                            </div>
                            <div className="search_main">
                                  <input src="text" placeholder="Search by name" />
                                  <IoSearch />
                              </div>
                              <div className="select_main">
                                  <div className="dropdown">
                                      <button
                                          className="btn btn-secondary dropdown-toggle"
                                          type="button"
                                          id="dropdownMenuButton1"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                      >
                                          Filter by : <span>{sortFilter}</span>
                                      </button>
                                      <ul
                                          className="dropdown-menu"
                                          aria-labelledby="dropdownMenuButton1"
                                      >
                                          <li>
                                              <a
                                                  className="dropdown-item"
                                                  href="#"
                                                  onClick={handleSortBy}
                                              >
                                                  Newest Date
                                              </a>
                                          </li>
                                          <li>
                                              <a
                                                  className="dropdown-item"
                                                  href="#"
                                                  onClick={handleSortBy}
                                              >
                                                  Name A-Z 
                                              </a>
                                          </li>
                                          <li>
                                              <a
                                                  className="dropdown-item"
                                                  href="#"
                                                  onClick={handleSortBy}
                                              >
                                                  Name Z-A
                                              </a>
                                          </li>
                                          <li>
                                              <a
                                                  className="dropdown-item"
                                                  href="#"
                                                  onClick={handleSortBy}
                                              >
                                                  Oldest Date
                                              </a>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                          </div>

                          <div className='issuer_table_wrp'>
                              <div className='table-respo issuer_table_main table-common'>
                                  <div className='table'>
                                      <div className='thead'>
                                          <div className='tr'>
                                              <span className='th'>Issuer ID</span>
                                              <span className='th'>Name</span>
                                              <span className='th'>Country</span>
                                              <span className='th'>Email</span>
                                              <span className='th'>Category</span>
                                              <span className='th'>Date Submitted</span>
                                              <span className='th'>Status</span>
                                          </div>
                                      </div>
                                      <div className='tbody'>
                                          {
                                              issuerTable.map((item, index) => {
                                                  return (
                                                    // onClick={navigate("/")}
                                                      <div className={`tr ${item.status.toLocaleLowerCase() == 'new' ? 'cur-pointer' : ''}`} onClick={() => {redirectDetail(item.status)}} >
                                                          <span className='table_td td'>{item.issuerID}</span>
                                                          <span className='table_td td'>{item.name}</span>
                                                          <span className='table_td td'>{item.country}</span>
                                                          <span className='table_td td'>{item.email}</span>
                                                          <span className='table_td td'>{item.category}</span>
                                                          <span className='table_td td'>{item.dateSubmitted}</span>
                                                          <span className={`table_td td`}>
                                                            <span className={`${item.status.toLocaleLowerCase() == 'new' ? 'newStatus' : ''}`}>{item.status}</span>
                                                          </span>
                                                      </div>
                                                  )
                                              })
                                          }
                                      </div>
                                  </div>
                              </div>
                          </div>


                      </div>
                      {/* <div className="dsh_footer_wrap">
              <Footer />
            </div> */}
                  </div>
              </main>
          </>
      </>
  )
}

export default Issuers